import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class CountryService {
    static async getAllCountry(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.COUNTRY; //endpoint
        const requestModel = { storeId };

        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch Country.');
            return [];
        }
    }

    // Create
    static async addNewCountry(data) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.COUNTRY; // endpoint

        responseModel = await handlePostAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Country added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new Country.');
        }
    }


    // Get by ID
    static async getCountryById(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COUNTRY}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch Country by ID');
        }
    }

    // Update 
    static async updateCountryById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COUNTRY}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Country updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update Country.');
        }
    }


    // Delete 
    static async deleteCountry(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COUNTRY}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete Country data.');
            }
        } catch (error) {
            console.error('Error deleting Country data:', error);
            throw error;
        }
    }

    // Delete  by IDs
    static async deleteManyCountry(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COUNTRY}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
